import { getLang } from "../../../../js/utils/functions";
import * as LiveQueryParams from "../constants/liveQueryParams";

const getCourseBaseUrl = (courseId) => `/${getLang}/courses/${courseId}`;

const getFacebookLivesBaseUrl = () => `/${getLang}/live`;

const livesBasePath = "/lives";

export const redirectToLivePage = (courseId, liveSessionId) => {
  if (!courseId || !liveSessionId) {
    return;
  }

  window.location.assign(`${getCourseBaseUrl(courseId)}${livesBasePath}/${liveSessionId}`);
};

export const redirectToLiveRecordingPage = (courseId, liveSessionId) => {
  if (!courseId || !liveSessionId) {
    return;
  }

  window.location.assign(
    `${getCourseBaseUrl(courseId)}${livesBasePath}/${liveSessionId}/recording`
  );
};

export const redirectToScheduleNewLive = (courseId) => {
  if (!courseId) {
    return;
  }

  window.location.assign(`${getCourseBaseUrl(courseId)}${livesBasePath}/new`);
};

export const redirectToScheduleEditLive = (courseId, liveSessionId) => {
  if (!courseId || !liveSessionId) {
    return;
  }

  window.location.assign(`${getCourseBaseUrl(courseId)}${livesBasePath}/${liveSessionId}/edit`);
};

export const redirectToCourseLanding = (courseId, showLiveFeedback) => {
  if (!courseId) {
    return;
  }

  window.location.assign(
    `${getCourseBaseUrl(courseId)}${showLiveFeedback ? "?show_live_feedback=true" : ""}`
  );
};

export const redirectToCourseLives = (courseId, showSetupModal) => {
  if (!courseId) {
    return;
  }

  window.location.assign(
    `${getCourseBaseUrl(courseId)}${livesBasePath}${
      showSetupModal ? `?${LiveQueryParams.SHOW_SETUP_INSTRUCTIONS}=true` : ""
    }`
  );
};

export const redirectToFacebookLivesLanding = () => {
  window.location.assign(getFacebookLivesBaseUrl());
};

export const redirectToFacebookLivePage = (liveSessionId) => {
  if (!liveSessionId) {
    return;
  }

  window.location.assign(`${getFacebookLivesBaseUrl()}/${liveSessionId}`);
};
